const { iterateKeywords } = require("../helper");

$(document).ready(function () {
  $("#faq-search-bar").on("change keyup paste click", function () {
    const searchTerm = $(this).val();
    const searchArray = searchTerm.split(" ");
    let panelContent, panelTitle, keywords;

    if (searchTerm != "") {
      $(".faq-inner").hide();
      $(".faq-anchor").hide();
    } else {
      $(".faq-inner").show();
      $(".faq-anchor").show();
    }

    $("#accordion .panel").each(function () {
      keywords = $(this).data("keywords").split(",");
      panelTitle = "#" + $(this).find(".panel-title").children().attr("id");
      panelContent = "#" + $(this).find(".panel-body").attr("id");

      if (iterateKeywords(searchArray, keywords) === true) {
        $(this).show();
      } else if ($(panelTitle + ":filter(" + searchTerm + ")").length > 0) {
        $(panelTitle + ":filter(" + searchTerm + ")")
          .closest(".panel")
          .show();
      } else {
        $(this).hide();
        $(panelContent + ":not(:filter(" + searchTerm + "))")
          .closest(".panel")
          .hide();
        $(panelContent + ":filter(" + searchTerm + ")")
          .closest(".panel")
          .show();
      }
    });
  });

  $(".faq-anchor > a").on("click", function (e) {
    e.preventDefault();
    const data = $(this).attr("href");

    $("html, body").animate(
      {
        scrollTop: $("#accordion > .panel-group > " + data).offset().top - 100,
      },
      800
    );
  });
});
